/** Pendant zu `IwmDashboardNavCard.Redirect` und `IwmNavbarItem.GetHref`. */

import type { ChinaAppSysView } from '../types/entities';
import { EntityTypes } from '../types/enums';

/** Ziel einer View; Entitäten ohne eigene Seite liefern einen leeren String. */
export function buildViewHref(view: ChinaAppSysView): string {
  switch (view.Entity) {
    case EntityTypes.Bestellposition:
      return `/bestellposition/${view.Id}`;
    case EntityTypes.Container:
      return `/container/${view.Id}`;
    case EntityTypes.Rechnung:
      return `/rechnung/${view.Id}`;
    case EntityTypes.Rechnungszuordnung:
      return `/rechnungszuordnung/${view.Id}`;
    default:
      return '';
  }
}
